import { mapMutations } from 'vuex'

import _ from 'lodash'

var mixins = {
	computed: {
		sortedData() {
			return _.orderBy(this.modelList, this.sortBy, [this.sortType])
		},
		/**
		 * Verifica se o botão de exclusão deve estar desabilitado
		 * de acordo com a verificação se existe checkbox marcado
		 */
		isDeleteButtonDisabled() {
			return this.modelList.filter((f) => f.isCheckedToDelete).map((m) => m.id).length === 0
		},
		/**
		 * Retorna os ids dos models que foram marcados para serem excluidos
		 */
		modelsIdWithCheckedToDelete() {
			return this.modelList.filter((f) => f.isCheckedToDelete).map((m) => m.id)
		},
		/**
		 * Retorna os objetos que devem ser exibidos atualmente de acordo
		 * com a pagina atual
		 */
		modelsToBeShowedAndTotal: function () {
			let modelsFiltred = this.sortedData

			/**
			 * Retorna as colunas que estao sendo exibidas para a tabela
			 */
			// const columns = this.tableHeaders
			//   .filter((f) => {
			//     return f.isActive
			//   })
			//   .map((m) => m.key)

			/**
			 * Filtrando pelo campo de pesquisa
			 */
			let textFilter = this.textFilter.toLowerCase()
			modelsFiltred = modelsFiltred.filter((item) => {
				// const model = _.pick(item, columns)
				const atualModel = Object.values(item).join(' ')
				return atualModel.toLowerCase().includes(textFilter)
			})

			return {
				items: modelsFiltred.slice(this.atualStartIndex, this.atualEndIndex),
				total: modelsFiltred.length,
			}
		},

		modelsToBeShowedAndTotalPagination: function () {
			let modelsFiltred = this.sortedData
			return {
				items: modelsFiltred.slice(this.atualStartIndex, this.atualEndIndex),
				total: modelsFiltred.length > 0 ? modelsFiltred[0].totalRegistros : 0,
			}
		},
	},
	data: () => {
		return {
			/**
			 * Desabilita o botao para salvar o formulario
			 */
			disableSaveButton: false,
			/**
			 * Verifica se esta editando um registro
			 */
			isEdit: false,
			/**
			 * Verifica se esta criando um registro
			 */
			isCreate: false,
			/**
			 * Lista de Models que sera exibido na tabela
			 */
			modelList: [],
			/**
			 * Lista que contem as propriedades que serão baseadas para ordenacao da lista de objetos
			 */
			orderTable: [],
			/**
			 * Verifica se deve exibir ou nao o formulario
			 */
			showForm: false,
			/**
			 * Titulo que deve ser exibido no formulario
			 */
			titleForm: '',
			/**
			 * Filtro do que é digitado no campo de pesquisa
			 */
			textFilter: '',
			/**
			 * propriedade na qual lista de registros deve ser baseada ao realizar ordenação
			 */
			sortBy: undefined,
			/**
			 * forma com que ordenação ira ocorrer, ascendente ou descendente
			 */
			sortType: undefined,
		}
	},
	methods: {
		...mapMutations('moduleMessages', ['mutationShowMessage']),

		/**
		 * Limpa os atributos de Model
		 */
		cleanModel() {
			for (let propertieName in this.model) {
				if (Array.isArray(this.model[propertieName])) {
					this.model[propertieName] = []
				} else if (typeof this.model[propertieName] === 'boolean') {
					this.model[propertieName] = false
				} else if (typeof this.model[propertieName] === 'number') {
					this.model[propertieName] = 0
				} else {
					this.model[propertieName] = ''
				}
			}
		},
	},
	watch: {
		/**
		 * Watcher para que sempre volte para a primeira pagina apos realizar filtro
		 */
		textFilter: function () {
			this.$refs.ref__pagination.resetToFirstPage()
		},
	},
}

export default mixins
